<template>
  <div>
    <div class="d-flex">
      <div class="flex-grow-1">
        <h3>{{ doc.senderCode?doc.senderCode:doc.caseId }} {{ doc.subject }}</h3>
        <div class="text-body-2">
          <span class="mr-4 grey--text">{{ $t('eDocInternal.sendDocEntity') }}：{{ $chPtObjData('chinSenderEntityName', doc) }}</span>
          <!-- <v-chip
            color="red"
            outlined
            small
          >
            緊急
          </v-chip> -->
        </div>
      </div>
      <s-class-pdf-muti
        v-model="dialog"
        :file-ctxs="files"
      />
      <s-view-doc-btn
        @previewFile="prepareFileList()"
      />
      <v-btn
        v-if="doc.dfProcessId && $config.isBrowser"
        icon
        large
        :loading="downloadBatchDocLoading"
        @click="downloadBatchDocument(doc.dfProcessId)"
      >
        <v-icon color="deep-orange lighten-2">
          {{ mdiDownload }}
        </v-icon>
      </v-btn>
    </div>
    <div class="d-flex flex-wrap align-center mb-2 text-body-2">
      <span class="mr-4">
        <s-name-tooltip
          :name="$chPtObjData('chinSenderName', doc)"
          :euid="doc.senderEuid"
        />
      </span>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <span
            class="mr-4"
            v-bind="attrs"
            v-on="on"
          >
            {{ $t('eDocSuggest.history.receiver') }}：{{ staffList.length }}{{ $t('eDocInternal.person') }}
            <v-icon
              small
            >{{ mdiMenuDown }}</v-icon>
          </span>
        </template>
        <v-list dense>
          <!-- <v-subheader class="px-4">
            下一位
          </v-subheader> -->
          <v-list-item
            v-for="item in staffList"
            :key="item.id"
          >
            <v-list-item-title>
              {{ showReceiverOrGroupName(item) }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer />
      <span class="text-caption grey--text">{{ momentWithHyphen(doc.processCreatedTime).format('YYYY-MM-DD HH:mm') }}</span>
    </div>
    <v-divider />
  </div>
</template>

<script>
import { momentWithHyphen } from '@/utils/datetimeUtil'
// import SClassPdfMutiDemoUseOnly from '@/components/SClassPdfMutiDemoUseOnly'
import docFlowApi from '@/api/eDocInternal/docFlow'
import SClassPdfMuti from '@/components/SClassPdfMuti'
// import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
// import { globalModule } from '@/store/moduleName'
// import { breakSubErrors } from '@/utils/messageUtil'
import SViewDocBtn from './SViewDocBtn.vue'
import { mdiMenuDown, mdiDownload } from '@mdi/js'
import { docFlowMethod } from '@/mixins/docFlowMethod'
import SNameTooltip from '@/components/SNameTooltip.vue'

export default {
  components: {
    SClassPdfMuti,
    // SClassPdfMutiDemoUseOnly,
    SViewDocBtn,
    SNameTooltip
  },
  mixins: [docFlowMethod],
  props: {
    doc: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      mdiMenuDown: mdiMenuDown,
      mdiDownload: mdiDownload,
      staffList: [],
      files: [],
      dialog: false,
      downloadBatchDocLoading: false
      // encryptedFileKey: null
    }
  },
  watch: {

  },
  mounted () {
    this.getParentProcessForwardInfo()
  },
  // async create () {
  //   // this.getParentProcessForwardInfo()
  //   this.encryptedFileKey = await this.getEncryptedDocumentKey(this.doc.dfProcessId)
  //   console.log('encrypted file key: ' + this.encryptedFileKey)
  // },
  methods: {
    async getParentProcessForwardInfo () {
      // console.log('getParentProcessForwardInfo : ' + JSON.stringify(this.doc))
      await docFlowApi.getParentProcessForwardInfo(this.doc.dfProcessId, resp => {
        this.staffList = resp.data
      })
    },

    prepareFileList () {
      if (this.files && this.files.length && this.decryptedFileKey) {
        this.dialog = true
      } else {
        this.previewFileList(this.doc.dfProcessId)
      }
    },

    momentWithHyphen
  }
}
</script>
